import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { EssenceBalance } from '#src/components/balance/EssenceBalance/index.tsx';
import { GemsBalance } from '#src/components/commonGame/GemsBalance/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { SUPPORTED_CARD_SETS } from '#src/lib/cardSets.ts';
import { getCommonCardShardsCount } from '#src/lib/currentUser/index.tsx';

type Props = {
  cardSetSlugs?: string[];
};
export const SeriesBalance = ({
  cardSetSlugs = SUPPORTED_CARD_SETS,
}: Props) => {
  const { currentUser } = useCurrentUserContext();
  const isSimplifiedNav = useSeriesNav();

  return (
    <Horizontal>
      <GemsBalance balance={currentUser?.gemsBalances[0]?.amount || 0} />
      {cardSetSlugs.map(
        slug =>
          (slug === 'winter' ||
            (slug === 'common-base-set' && !isSimplifiedNav)) && (
            <EssenceBalance
              key={slug}
              value={getCommonCardShardsCount(currentUser, slug) || 0}
              rarity={Rarity.common}
              cardSetSlug={slug}
            />
          )
      )}
    </Horizontal>
  );
};
